// Since our formatted logs (using Pino) is injected by the start / serve scripts, regular console.log is used inside the app

type Data = Record<string, unknown>
type LogMethod = (data: Data, message: string) => void
type LogMethodOverload = (message: string) => void
type LogMethodOverloadOnlyData = (data: Data) => void
type LogMethodWithOverloads = LogMethod & LogMethodOverload & LogMethodOverloadOnlyData

type Logger = {
  level: 'debug' | 'info' | 'warn' | 'error'
  debug: LogMethodWithOverloads
  info: LogMethodWithOverloads
  warn: LogMethodWithOverloads
  error: LogMethodWithOverloads
}

const createLogMethod = (
  logFunction: (message?: unknown, ...optionalParams: unknown[]) => void
): LogMethod & LogMethodOverload & LogMethodOverloadOnlyData => {
  return ((firstParam: Data | string, secondParam?: string) => {
    if (typeof firstParam === 'string') {
      logFunction(firstParam, secondParam as unknown)
    } else if (secondParam !== undefined) {
      logFunction(secondParam, firstParam)
    } else {
      logFunction(firstParam)
    }
  }) as LogMethod & LogMethodOverload & LogMethodOverloadOnlyData
}

const logger: Logger = {
  // TODO: Handle log level
  level: 'info',
  // TODO: Handle debug level
  // debug: createLogMethod(console.debug),
  debug: () => {},
  info: createLogMethod(console.log),
  warn: createLogMethod(console.warn),
  error: createLogMethod(console.error),
}

export const log = logger
